import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import { UserItemStore } from 'src/stores/users-store';
import { GroupType } from 'src/stores/groups-store';
import { AppConfig, container } from 'src/inversify.config';
import { Alert, Spin, Tabs } from 'antd';

import UserGeneralPropertyEditCard from './components/user-general-properties-card';
import UserGroupsTab from './components/user-groups-tab';
import UserRolesTab from './components/user-roles-tab';
import UserAuditLogsTab from './components/user-logs-tab';
import { AppConfiguration } from 'src/core/services/configuration.service';

import 'src/assets/cards-detail-view-layout.less';
import { useLocation, useParams } from 'react-router-dom';
import { ENV } from 'src/';

const UserDetailPage: FC = () => {
  const { t } = useTranslation();
  const params = useParams();
  let userId = params.id!;
  const userStore = container.get(UserItemStore);
  const userState = userStore.state;
  const [userName, setUserName] = useState('');
  const config: AppConfiguration = useContext(AppConfig);
  const location = useLocation();
  const state = location.state;

  useEffect(() => {
    userStore.getUserItem(userId, [GroupType.Default]);
    const mainContainer = document.querySelector('main.ant-layout-content');
    if (mainContainer) {
      mainContainer.classList.add('edit-mode');
    }
    return () => {
      mainContainer && mainContainer.classList.remove('edit-mode');
    };
  }, [userId, userStore]);

  if (userState.item.value) {
    setHeader(t('User {0}').replace('{0}', userState.item.displayName.value));
    if (userState.item.displayName.value !== userName) {
      setUserName(userState.item.displayName.value);
    }
    if (state && 'organizationId' in state) {
      setRoutes([
        { path: '', breadcrumbName: t('Home') },
        { path: 'organizations', breadcrumbName: t('Organizations') },
        { path: `organizations/${state.organizationId}`, breadcrumbName: state.organizationDisplayName },
        { path: userState.item.id.value, breadcrumbName: userState.item.displayName.value },
      ]);
    } else {
      setRoutes([
        { path: '', breadcrumbName: t('Home') },
        { path: 'users', breadcrumbName: t('Users') },
        { path: userState.item.id.value, breadcrumbName: userState.item.displayName.value },
      ]);
    }
  }

  return (
    <div className="entity-details_card-grid-container">
      <Spin spinning={userState.isBusy.get()} size="large">
        {userState.errorMessage.value && (
          <Alert message={config.environment === ENV.DEV ? userState.errorMessage.value : t('UnexpectedError')} type="error" />
        )}
        {!userState.errorMessage.value && (
          <div className="entity-details_card-grid-container__form-container">
            <div className="entity-details_card-grid-container__left-container" style={{ width: '30%', minWidth: 200, borderRadius: 8 }}>
              <UserGeneralPropertyEditCard userId={userId} />
            </div>
            <div className="entity-details_card-grid-container__right-container" style={{ width: '70%', minWidth: 200, borderRadius: 8 }}>
              <Tabs defaultActiveKey="1" type="card">
                <Tabs.TabPane tab={t('Groups')} key="1">
                  <div className="tab-container">
                    <UserGroupsTab userOrganizations={userState.item?.value?.organizations?.map((x) => x.organizationId)} />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t('Roles')} key="2">
                  <div className="tab-container">
                    <UserRolesTab
                      userId={userId}
                      username={userName}
                      userOrganizations={userState.item?.value?.organizations?.map((x) => x.organizationId)}
                    />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab={t('AuditLogs')} key="3">
                  <div className="tab-container">
                    <UserAuditLogsTab userId={userId} />
                  </div>
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default UserDetailPage;
